import {
  ACTION_EDIT_SEO_TRANSLATION__REQUEST,
  ACTION_EDIT_SEO_TRANSLATION__SUCCESS,
  ACTION_EDIT_SEO_TRANSLATION__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_SEO_TRANSLATION__REQUEST:
    case ACTION_EDIT_SEO_TRANSLATION__SUCCESS:
      return null;

    case ACTION_EDIT_SEO_TRANSLATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
